import { b64toBlob } from './b64toBlob';

export const b64toFile = (
  image: string,
  type = 'image/png',
  fileName = 'File name'
) => {
  const blob = b64toBlob(image, type);
  return new File([blob], fileName, { type });
};
